stringUtil = require('resources/assets/coffee/Core/utils/string')

class exports.Repository

    constructor: (store = {}) ->
        @store = store

    get: (key, def = null) ->
        if key is ''
            return @store

        val = @_tryFind(key)

        if not val?
            return def

        return val


    set: (key, value) ->
        return stringUtil.setElementIn(key, value, @store)


    has: (key) ->
        if @_tryFind(key)?
            return true

        return false


    _tryFind: (key) ->

        try
            return stringUtil.toElementIn(key, @store)
        catch error
            return null
